var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sticky top-0 col-span-1 flex flex-col justify-end gap-3 bg-ds-foreground px-1 py-2 pb-5 md:px-5",class:_vm.className},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }